import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { SmartLink } from '../SmartLink';
import { plans } from '../../data/pricing';
export function PlanChip() {
  const [params] = useSearchParams();
  const plan = plans.find(p => p.id === params.get('plan')) ?? plans.find(p => p.popular) ?? plans[0];
  return <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-canvas-line bg-canvas-warm py-1.5 pl-3.5 pr-1.5 text-[13px] text-ink" data-id="element-530" data-mp="1a7zzw9rt7i3j">
      <span data-id="element-531" data-mp="hi17c4eep2u4">
        Plan: <span className="font-semibold" data-id="element-532" data-mp="hij9tirnwdah">{plan.name}</span>
      </span>
      <span aria-hidden="true" className="text-ink-muted" data-id="element-533" data-mp="hkdy97256njb">
        ·
      </span>
      <SmartLink href="/pricing" className="rounded-full px-2 py-0.5 font-semibold text-brand transition-colors duration-150 ease-out hover:bg-white hover:text-brand-hover" data-id="element-534" data-mp="wgldru2lv0s9">
        Change<span className="sr-only" data-id="element-535" data-mp="27wjtuhw7an2z"> plan</span>
      </SmartLink>
    </p>;
}